export function CanonicalizeUnicodeLocaleId(locale) {
	return Intl.getCanonicalLocales(locale)[0];
}
